import React, { useContext, useMemo } from 'react'
import { ScenarioStatesProviderContext } from '../providers/StatesProvider'

const useAssets = () => {
    const context = useContext(ScenarioStatesProviderContext)
    if (context === undefined) {
        throw new Error('useAssets must be used within a Scenario States Provider')
    }

    const { formData, orbitStartOption, setOrbitStartOption } = context
    const assets = formData.assets
    const { schedule, presim, hwilAssets, faultPlans, orbitalInsights } = useMemo(() => assets, [assets.faultPlans, assets.schedule, assets.presim, assets.hwilAssets, assets.orbitalInsights])
    return { schedule, presim, hwilAssets, faultPlans, orbitalInsights, orbitStartOption, setOrbitStartOption }
}

export default useAssets